// extracted by mini-css-extract-plugin
export default {"numArea":"BAutoPreviewCounts-module_numArea_a94e075d","forecast":"BAutoPreviewCounts-module_forecast_b2244cab","forecastNone":"BAutoPreviewCounts-module_forecastNone_cb9e04b9"};